import CryptoJS from 'crypto-js';

const SECRET_KEY = 'secret-key';

const Encrypt = (data) => {

    console.log(data, "Encrypted data")

    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
    return encryptedData;

};

const Decrypt  = (data) => {

    try {
        const bytes = CryptoJS.AES.decrypt(data, SECRET_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8); 

        return JSON.parse(decrypted);
    } catch (err) {
        console.error("Decryption failed:", err);
        return null;
    }

};


 export { Encrypt, Decrypt};